<template>
    <div :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']" ref="box">
        <div class="header acea-row row-center-wrapper" :style="'opacity:' + opacity" ref="header">
            <div class="item" :class="navActive === index ? 'on' : ''" v-for="(item, index) in navList" :key="index"
                @click="asideTap(index)">
                {{ item }}
            </div>
        </div>
        <div id="title0">
            <product-con-swiper :img-urls="storeInfo.slider_image"
                :videoline="storeInfo.video_link"></product-con-swiper>
            <div class="wrapper">
                <div class="share acea-row row-between row-bottom">
                    <div class="money font-color-red">
                        ￥<span class="num">{{ attr.productSelect.price }}</span><span class="vip-money"
                            v-if="storeInfo.vip_price && storeInfo.vip_price > 0">￥{{ storeInfo.vip_price }}</span><img
                            src="@assets/images/vip.png" class="image"
                            v-if="storeInfo.vip_price && storeInfo.vip_price > 0" />
                    </div>
                    <div class="iconfont icon-fenxiang" @click="listenerActionSheet"></div>
                </div>
                <div class="introduce">{{ storeInfo.store_name }}</div>
                <div class="label acea-row row-between-wrapper">
                </div>

            </div>
            <div class="attribute acea-row row-between-wrapper" @click="selecAttrTap" v-if="attr.productAttr.length">
                <div>
                    {{ attrTxt }}：<span class="atterTxt">{{ attrValue }}</span>
                </div>
                <div class="iconfont icon-jiantou"></div>
            </div>

        </div>

        <div class="product-intro" id="title3">
            <div class="title">详情介绍</div>
            <div class="conter" v-html="storeInfo.description"></div>
        </div>
        <div style="height:1.8rem;"></div>
        <div class="footer acea-row row-between-wrapper">
                <div class="payDeposit bg-color-red" @click="tapBuy" v-if="attr.productSelect.stock > 0">
                    去付款
                </div>
                <div class="payDeposit bg-color-hui" v-else>已售罄</div>
            
        </div>
        <Share-red-packets :priceName="priceName" v-on:changeFun="changeFun" v-if="priceName !== 0"></Share-red-packets>
        <Product-window v-on:changeFun="changeFun" :attr="attr" :iSplus="iSplus"></Product-window>
        <StorePoster v-on:setPosterImageStatus="setPosterImageStatus" :posterImageStatus="posterImageStatus"
            :posterData="posterData"></StorePoster>
        <ShareInfo v-on:setShareInfoStatus="setShareInfoStatus" :shareInfoStatus="shareInfoStatus"></ShareInfo>
        <div class="generate-posters acea-row row-middle" :class="posters ? 'on' : ''">
            <div class="item" v-if="weixinStatus === true" @click="setShareInfoStatus">
                <div class="iconfont icon-weixin3"></div>
                <div class="">发送给朋友</div>
            </div>
            <div class="item" @click="setPosterImageStatus">
                <div class="iconfont icon-haibao"></div>
                <div class="">生成海报</div>
            </div>
        </div>
        <div class="mask" @touchmove.prevent @click="listenerActionClose" v-show="posters"></div>
        <div class="geoPage" v-if="mapShow">
            <iframe width="100%" height="100%" frameborder="0" scrolling="no" :src="'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
                system_store.latitude +
                ',' +
                system_store.longitude +
                '&referer=' +
                mapKey
                ">
            </iframe>
        </div>
    </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import ProductConSwiper from "@components/ProductConSwiper";
import UserEvaluation from "@components/UserEvaluation";
import ShareRedPackets from "@components/ShareRedPackets";
import ProductWindow from "@components/ProductWindow";
import StorePoster from "@components/StorePoster";
import ShareInfo from "@components/ShareInfo";
import { goShopDetail } from "@libs/order";
import debounce from "lodash.debounce";
import {
    getProductDetail,
    postCartAdd,
    getCartCount,
    getProductCode,
} from "@api/store";
import {
    getUserInfo
} from "@api/user";
import { isWeixin } from "@utils/index";
import { wechatEvevt } from "@libs/wechat";
import { imageBase64 } from "@api/public";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
let NAME = "DepositDetail";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
    name: NAME,
    components: {
        swiper,
        swiperSlide,
        ProductConSwiper,
        UserEvaluation,
        ShareRedPackets,
        ProductWindow,
        StorePoster,
        ShareInfo
    },
    data: function () {
        return {
            iSplus: true,
            shareInfoStatus: false,
            weixinStatus: false,
            mapShow: false,
            mapKey: "",
            posterData: {
                image: "",
                title: "",
                price: "",
                code: ""
            },
            posterImageStatus: false,
            animated: false,

            attr: {
                cartAttr: false,
                productAttr: [],
                productSelect: {}
            },
            isOpen: false, //是否打开属性组件
            productValue: [],
            id: 0,
            storeInfo: {},
            attrTxt: "请选择",
            attrValue: "",
            cart_num: 1, //购买数量
            replyCount: "",
            replyChance: "",
            reply: [],
            priceName: 0,
            CartCount: 0,
            posters: false,
            banner: [{}, {}],
            swiperRecommend: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                autoplay: false,
                loop: false,
                speed: 1000,
                observer: true,
                observeParents: true
            },
            //goodList: [],
            //system_store: {},
            storeSelfMention: true,
            //storeItems: {},
            //activity: [],
            navList: [],
            sectionTitleIds: ["title0", "title3"],
            goodList: [],
            lock: false,
            navActive: 0,
            opacity: 0
        };
    },
    computed: mapGetters(["isLogin"]),
    watch: {
        $route(n) {
            if (n.name === NAME) {
                this.id = n.params.id;
                this.storeInfo.slider_image = [];
                this.productCon();
            }
        }
    },
    updated() {
        // window.scroll(0, 0);
    },
    created() {
        this._debouncedScroll = debounce(() => {
            this.updateSectionNav();
        }, 500);
    },
    mounted: function () {
        this.bindScrollListener();
        this.id = this.$route.params.id;
        this.storeInfo.slider_image = [];
        this.productCon();
        window.addEventListener("scroll", this.handleScroll);
    },
    activated() {
        this.bindScrollListener();
    },
    deactivated() {
        this.unbindScrollListener();
    },
    methods: {

        handleScroll() {
            let top = document.body.scrollTop || document.documentElement.scrollTop;
            let opacity = top / 350;
            opacity = opacity > 1 ? 1 : opacity;
            this.opacity = opacity;
        },
        bindScrollListener() {
            if (this._scrollBound || !this._debouncedScroll) return;
            this._scrollBound = true;
            document.addEventListener("scroll", this._debouncedScroll, false);
        },
        unbindScrollListener() {
            if (!this._scrollBound || !this._debouncedScroll) return;
            this._scrollBound = false;
            document.removeEventListener("scroll", this._debouncedScroll, false);
            if (this._debouncedScroll.cancel) {
                this._debouncedScroll.cancel();
            }
        },
        getSectionElements() {
            const root = this.$el;
            if (!root) return [];
            return this.sectionTitleIds
                .map((id, navIndex) => {
                    const el = root.querySelector("#" + id);
                    return el ? { el, navIndex } : null;
                })
                .filter(Boolean);
        },
        updateSectionNav() {
            if (this.lock) {
                this.lock = false;
                return;
            }
            const header = this.$refs.header;
            if (!header) return;
            const headerHeight = header.offsetHeight;
            const scrollY =
                window.scrollY || document.documentElement.scrollTop || 0;
            const sections = this.getSectionElements();
            if (!sections.length) return;
            for (let i = 0; i < sections.length; i++) {
                const { el, navIndex } = sections[i];
                if (scrollY + headerHeight < el.offsetTop + el.offsetHeight) {
                    this.navActive = navIndex;
                    return;
                }
            }
            this.navActive = sections[sections.length - 1].navIndex;
        },
        asideTap(a) {
            this.$nextTick(() => {
                this.navActive = a;
                const titleId = this.sectionTitleIds[a];
                const root = this.$el;
                if (!titleId || !root) return;
                const element = root.querySelector("#" + titleId);
                const header = this.$refs.header;
                if (!element || !header) return;
                const scrollY =
                    window.scrollY || document.documentElement.scrollTop || 0;
                const top = element.offsetTop - header.offsetHeight - scrollY;
                this.lock = true;
                window.scrollBy({ top, left: 0, behavior: "smooth" });
            });
        },
        showChang: function () {
            if (isWeixin()) {
                let config = {
                    latitude: parseFloat(this.storeItems.latitude),
                    longitude: parseFloat(this.storeItems.longitude),
                    name: this.storeItems.name,
                    address: this.storeItems.address + this.system_store.detailed_address
                };
                wechatEvevt("openLocation", config)
                    .then(res => {
                        console.log(res);
                    })
                    .catch(res => {
                        if (res.is_ready) {
                            res.wx.openLocation(config);
                        }
                    });
            } else {
                if (!this.mapKey)
                    return this.$dialog.error(
                        "暂无法使用查看地图，请配置您的腾讯地图key"
                    );
                this.mapShow = true;
            }
        },
        updateTitle() {
            document.title = this.storeInfo.store_name || this.$route.meta.title;
        },

        setOpenShare: function () {
            var data = this.storeInfo;
            var href = location.href;
            if (isWeixin()) {
                if (this.isLogin) {
                    getUserInfo().then(res => {
                        href =
                            href.indexOf("?") === -1
                                ? href + "?spread=" + res.data.uid
                                : href + "&spread=" + res.data.uid;
                        var configAppMessage = {
                            desc: data.store_info,
                            title: data.store_name,
                            link: href,
                            imgUrl: data.image
                        };
                        wechatEvevt(
                            [
                                "updateAppMessageShareData",
                                "updateTimelineShareData",
                                "onMenuShareAppMessage",
                                "onMenuShareTimeline"
                            ],
                            configAppMessage
                        )
                            .then(res => {
                                console.log(res);
                            })
                            .catch(res => {
                                if (res.is_ready) {
                                    res.wx.updateAppMessageShareData(configAppMessage);
                                    res.wx.onMenuShareAppMessage(configAppMessage);
                                    res.wx.updateTimelineShareData(configAppMessage);
                                    res.wx.onMenuShareTimeline(configAppMessage);
                                }
                            });
                    });
                } else {
                    var configAppMessage = {
                        desc: data.store_info,
                        title: data.store_name,
                        link: href,
                        imgUrl: data.image
                    };
                    wechatEvevt(
                        [
                            "updateAppMessageShareData",
                            "updateTimelineShareData",
                            "onMenuShareAppMessage",
                            "onMenuShareTimeline"
                        ],
                        configAppMessage
                    )
                        .then(res => {
                            console.log(res);
                        })
                        .catch(res => {
                            if (res.is_ready) {
                                res.wx.updateAppMessageShareData(configAppMessage);
                                res.wx.onMenuShareAppMessage(configAppMessage);
                                res.wx.updateTimelineShareData(configAppMessage);
                                res.wx.onMenuShareTimeline(configAppMessage);
                            }
                        });
                }
            }
        },
        setShareInfoStatus: function () {
            this.shareInfoStatus = !this.shareInfoStatus;
            this.posters = false;
        },
        shareCode: function (value) {
            var that = this;
            getProductCode(that.id).then(res => {
                if (res.data.code) that.posterData.code = res.data.code;
                value === false && that.listenerActionSheet();
            });
        },
        setPosterImageStatus: function () {
            var sTop = document.body || document.documentElement;
            sTop.scrollTop = 0;
            this.posterImageStatus = !this.posterImageStatus;
            this.posters = false;
        },
        //产品详情接口；
        productCon: function () {
            let that = this;
            getProductDetail(that.id)
                .then(res => {
                    that.$set(that, "storeInfo", res.data.storeInfo);
                    that.$set(that.attr, "productAttr", res.data.productAttr);
                    that.$set(that, "productValue", res.data.productValue);
                    that.$set(that, "replyCount", res.data.replyCount);
                    that.$set(that, "replyChance", res.data.replyChance);
                    that.reply = res.data.reply ? [res.data.reply] : [];
                    that.$set(that, "reply", that.reply);
                    that.$set(that, "priceName", res.data.priceName);
                    that.posterData.image = that.storeInfo.image_base;
                    that.activity = res.data.activity ? res.data.activity : [];
                    if (that.storeInfo.store_name.length > 30) {
                        that.posterData.title =
                            that.storeInfo.store_name.substring(0, 30) + "...";
                    } else {
                        that.posterData.title = that.storeInfo.store_name;
                    }
                    that.storeSelfMention = res.data.store_self_mention ? true : false;
                    that.posterData.price = that.storeInfo.price;
                    that.posterData.code = that.storeInfo.code_base;
                    that.system_store = res.data.system_store;
                    let good_list = res.data.good_list || [];
                    let goodArray = [];
                    let count = Math.ceil(good_list.length / 6);
                    for (let i = 0; i < count; i++) {
                        var list = good_list.slice(i * 6, i * 6 + 6);
                        if (list.length) goodArray.push({ list: list });
                    }
                    that.mapKey = res.data.mapKey;
                    that.$set(that, "goodList", goodArray);
                    let navList = ["商品", "详情"];
                    that.navList = navList;
                    that.updateTitle();
                    that.DefaultSelect();
                    that.getCartCount();
                    that.getImageBase64();
                    that.setOpenShare();
                })
                .catch(res => {
                    that.$dialog.error(res.msg);
                    that.$router.go(-1);
                });
        },
        getImageBase64: function () {
            let that = this;
            imageBase64(this.posterData.image, that.posterData.code)
                .then(res => {
                    that.posterData.image = res.data.image;
                    that.posterData.code = res.data.code;
                    that.isLogin && that.shareCode();
                })
                .catch(() => {
                    that.isLogin && that.shareCode();
                });
        },
        //默认选中属性；
        findFirstInStockAttrs: function () {
            const productAttr = this.attr.productAttr;
            const productValue = this.productValue;
            const selected = [];

            const dfs = (dim) => {
                if (dim === productAttr.length) {
                    const key = selected.slice().sort().join(",");
                    if (productValue[key] && productValue[key].stock > 0) {
                        return { key, attrs: selected.slice() };
                    }
                    return null;
                }
                for (let j = 0; j < productAttr[dim].attr_value.length; j++) {
                    selected.push(productAttr[dim].attr_value[j].attr);
                    const result = dfs(dim + 1);
                    if (result) return result;
                    selected.pop();
                }
                return null;
            };

            return dfs(0);
        },
        DefaultSelect: function () {
            let productAttr = this.attr.productAttr;
            let productSelectKey = "";
            let selectedAttrs = [];

            if (productAttr.length) {
                const found = this.findFirstInStockAttrs();
                if (found) {
                    productSelectKey = found.key;
                    selectedAttrs = found.attrs;
                }
            } else {
                for (var key in this.productValue) {
                    if (this.productValue[key].stock > 0) {
                        productSelectKey = key;
                        break;
                    }
                }
            }

            for (let i = 0; i < productAttr.length; i++) {
                this.$set(productAttr[i], "index", selectedAttrs[i] || "");
            }

            let productSelect = this.productValue[productSelectKey];
            if (productSelect && productAttr.length) {
                this.$set(
                    this.attr.productSelect,
                    "store_name",
                    this.storeInfo.store_name
                );
                this.$set(this.attr.productSelect, "image", productSelect.image);
                this.$set(this.attr.productSelect, "price", productSelect.price);
                this.$set(this.attr.productSelect, "stock", productSelect.stock);
                this.$set(this.attr.productSelect, "unique", productSelect.unique);
                this.$set(this.attr.productSelect, "cart_num", 1);
                this.$set(this, "attrValue", productSelectKey);
                this.$set(this, "attrTxt", "已选择");
            } else if (!productSelect && productAttr.length) {
                this.$set(
                    this.attr.productSelect,
                    "store_name",
                    this.storeInfo.store_name
                );
                this.$set(this.attr.productSelect, "image", this.storeInfo.image);
                this.$set(this.attr.productSelect, "price", this.storeInfo.price);
                this.$set(this.attr.productSelect, "stock", 0);
                this.$set(this.attr.productSelect, "unique", "");
                this.$set(this.attr.productSelect, "cart_num", 0);
                this.$set(this, "attrValue", "");
                this.$set(this, "attrTxt", "请选择");
            } else if (!productSelect && !productAttr.length) {
                this.$set(
                    this.attr.productSelect,
                    "store_name",
                    this.storeInfo.store_name
                );
                this.$set(this.attr.productSelect, "image", this.storeInfo.image);
                this.$set(this.attr.productSelect, "price", this.storeInfo.price);
                this.$set(this.attr.productSelect, "stock", this.storeInfo.stock);
                this.$set(
                    this.attr.productSelect,
                    "unique",
                    this.storeInfo.unique || ""
                );
                this.$set(this.attr.productSelect, "cart_num", 1);
                this.$set(this, "attrValue", "");
                this.$set(this, "attrTxt", "请选择");
            }
        },
        //购物车；
        ChangeCartNum: function (changeValue) {
            //changeValue:是否 加|减
            //获取当前变动属性
            let productSelect = this.productValue[this.attrValue];
            //如果没有属性,赋值给商品默认库存
            if (productSelect === undefined && !this.attr.productAttr.length)
                productSelect = this.attr.productSelect;
            //无属性值即库存为0；不存在加减；
            if (productSelect === undefined) return;
            let stock = productSelect.stock || 0;
            let num = this.attr.productSelect;
            if (changeValue) {
                num.cart_num++;
                if (num.cart_num > stock) {
                    this.$set(this.attr.productSelect, "cart_num", stock ? stock : 1);
                    this.$set(this, "cart_num", stock ? stock : 1);
                }
            } else {
                num.cart_num--;
                if (num.cart_num < 1) {
                    this.$set(this.attr.productSelect, "cart_num", 1);
                    this.$set(this, "cart_num", 1);
                }
            }
        },
        //将父级向子集多次传送的函数合二为一；
        changeFun: function (opt) {
            if (typeof opt !== "object") opt = {};
            let action = opt.action || "";
            let value = opt.value === undefined ? "" : opt.value;
            this[action] && this[action](value);
        },

        //打开属性插件；
        selecAttrTap: function () {
            this.attr.cartAttr = true;
            this.isOpen = true;
        },
        changeattr: function (msg) {
            this.attr.cartAttr = msg;
            this.isOpen = false;
        },
        //选择属性；
        ChangeAttr: function (res) {
            let productSelect = this.productValue[res];
            if (productSelect) {
                this.$set(this.attr.productSelect, "image", productSelect.image);
                this.$set(this.attr.productSelect, "price", productSelect.price);
                this.$set(this.attr.productSelect, "stock", productSelect.stock);
                this.$set(this.attr.productSelect, "unique", productSelect.unique);
                this.$set(this.attr.productSelect, "cart_num", 1);
                this.$set(this, "attrValue", res);
                this.$set(this, "attrTxt", "已选择");
            } else {
                this.$set(this.attr.productSelect, "image", this.storeInfo.image);
                this.$set(this.attr.productSelect, "price", this.storeInfo.price);
                this.$set(this.attr.productSelect, "stock", 0);
                this.$set(this.attr.productSelect, "unique", "");
                this.$set(this.attr.productSelect, "cart_num", 0);
                this.$set(this, "attrValue", "");
                this.$set(this, "attrTxt", "请选择");
            }
        },

        goGoods(item) {
            goShopDetail(item).then(() => {
                window.scroll(0, 0);
                this.$router.push({ path: "/detail/" + item.id });
            });
        },
        //  点击加入购物车按钮
        joinCart: function () {
            //0=加入购物车
            this.goCat(0);
        },
        // 加入购物车；
        goCat: function (news) {
            let that = this,
                productSelect = that.productValue[this.attrValue];
            //打开属性
            if (that.attrValue) {
                //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
                that.attr.cartAttr = !that.isOpen ? true : false;
            } else {
                if (that.isOpen) that.attr.cartAttr = true;
                else that.attr.cartAttr = !that.attr.cartAttr;
            }
            //只有关闭属性弹窗时进行加入购物车
            if (that.attr.cartAttr === true && that.isOpen === false)
                return (that.isOpen = true);
            if (
                !this.attr.productSelect.cart_num ||
                parseInt(this.attr.productSelect.cart_num) <= 0
            )
                return that.$dialog.toast({ mes: "请输入购买数量" });
            //如果有属性,没有选择,提示用户选择
            if (
                that.attr.productAttr.length &&
                productSelect === undefined &&
                that.isOpen === true
            )
                return that.$dialog.toast({ mes: "产品库存不足，请选择其它" });
            let q = {
                productId: that.id,
                cartNum: that.attr.productSelect.cart_num,
                new: news,
                uniqueId:
                    that.attr.productSelect !== undefined
                        ? that.attr.productSelect.unique
                        : ""
            };
            postCartAdd(q)
                .then(function (res) {
                    that.isOpen = false;
                    that.attr.cartAttr = false;
                    if (news) {
                        if(that.id == 57) {
                            that.$router.push({ path: "/deposit/submit/" + res.data.cartId });
                        } else if(that.id == 60) {
                            that.$router.push({ path: "/review_deposit/submit/" + res.data.cartId });
                        } else {
                            that.$router.push({ path: "/order/submit/" + res.data.cartId });
                        }
                    } else {
                        that.$dialog.toast({
                            mes: "添加购物车成功",
                            callback: () => {
                                that.getCartCount(true);
                            }
                        });
                    }
                })
                .catch(res => {
                    that.isOpen = false;
                    return that.$dialog.toast({ mes: res.msg });
                });
        },
        //获取购物车数量
        getCartCount: function (isAnima) {
            let that = this;
            const isLogin = that.isLogin;
            if (isLogin) {
                getCartCount({ numType: 0 }).then(res => {
                    that.CartCount = res.data.count;
                    //加入购物车后重置属性
                    if (isAnima) {
                        that.animated = true;
                        setTimeout(function () {
                            that.animated = false;
                        }, 500);
                    }
                });
            }
        },
        //立即购买；
        tapBuy: function () {
            //  1=直接购买
            this.goCat(1);
        },
        listenerActionSheet: function () {
            if (isWeixin() === true) {
                this.weixinStatus = true;
            }
            this.posters = true;
        },
        listenerActionClose: function () {
            this.posters = false;
        }
    },
    beforeDestroy: function () {
        this.unbindScrollListener();
        window.removeEventListener("scroll", this.handleScroll);
    }
};
</script>
<style scoped>
.mask {
    z-index: 888 !important;
}

.activity_pin {
    width: auto;
    height: 0.44rem;
    background: linear-gradient(90deg,
            rgba(233, 51, 35, 1) 0%,
            rgba(250, 101, 20, 1) 100%);
    opacity: 1;
    border-radius: 0.22rem;
    padding: 0 0.2rem;
    margin-left: 0.19rem;
}

.activity_miao {
    width: auto;
    height: 0.44rem;
    padding: 0 0.2rem;
    background: linear-gradient(90deg,
            rgba(250, 102, 24, 1) 0%,
            rgba(254, 161, 15, 1) 100%);
    opacity: 1;
    border-radius: 0.22rem;
    margin-left: 0.19rem;
}

.iconfonts {
    color: #fff !important;
    font-size: 0.28rem;
    display: block;
}

.activity_title {
    font-size: 0.24rem;
    color: #fff;
}

.activity_kan {
    width: auto;
    height: 0.44rem;
    padding: 0 0.2rem;
    background: linear-gradient(90deg,
            rgba(254, 159, 15, 1) 0%,
            rgba(254, 178, 15, 1) 100%);
    opacity: 1;
    border-radius: 0.22rem;
    margin-left: 0.19rem;
}

.addressBox .phone {
    margin-left: 1.1rem;
}

.corlor-red {
    color: #fc4141;
}

.store-box {
    padding: 0 0.3rem;
    border-bottom: 1px solid #f5f5f5;
}

.geoPage {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 10000;
}

.product-con .header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 0.96rem;
    font-size: 0.3rem;
    color: #050505;
    background-color: #fff;
    z-index: 11;
    border-bottom: 0.01rem solid #eee;
}

.product-con .header .item {
    position: relative;
    margin: 0 0.35rem;
}

.product-con .header .item.on:before {
    position: absolute;
    width: 0.6rem;
    height: 0.05rem;
    background-repeat: no-repeat;
    content: "";
    background: linear-gradient(to left, #ff3366 0%, #ff6533 100%);
    background: -webkit-linear-gradient(to left, #ff3366 0%, #ff6533 100%);
    background: -moz-linear-gradient(to left, #ff3366 0%, #ff6533 100%);
    bottom: -0.1rem;
}

.product-con .store-info {
    margin-top: 0.2rem;
    background-color: #fff;
}

.product-con .store-info .title {
    font-size: 0.28rem;
    color: #282828;
    height: 0.8rem;
    line-height: 0.8rem;
    border-bottom: 0.01rem solid #f5f5f5;
}

.product-con .store-info .info {
    padding: 0 0.3rem;
    height: 1.26rem;
}

.store-info .icon-jiantou {
    color: #7a7a7a;
    font-size: 0.28rem;
}

.product-con .store-info .info .pictrue {
    width: 0.76rem;
    height: 0.76rem;
}

.product-con .store-info .info .pictrue img {
    width: 100%;
    height: 100%;
    border-radius: 0.06rem;
}

.product-con .store-info .info .text {
    width: 56%;
}

.product-con .store-info .info .text .name {
    font-size: 0.3rem;
    color: #282828;
}

.product-con .store-info .info .text .address {
    font-size: 0.24rem;
    color: #666;
    margin-top: 0.03rem;
}

.product-con .store-info .info .text .address .iconfont {
    color: #707070;
    font-size: 0.18rem;
    margin-left: 0.1rem;
}

.address_tit {
    max-width: 88% !important;
}

.addressTxt {
    width: auto;
    font-size: 0.24rem;
}

.product-con .store-info .info .iconfont {
    font-size: 0.4rem;
}

.product-con .superior {
    background-color: #fff;
    margin-top: 0.2rem;
}

.product-con .superior .title {
    height: 0.98rem;
}

.product-con .superior .title img {
    width: 0.3rem;
    height: 0.3rem;
}

.product-con .superior .title .titleTxt {
    margin: 0 0.2rem;
    font-size: 0.3rem;
    background-image: linear-gradient(to right, #f57a37 0%, #f21b07 100%);
    background-image: -webkit-linear-gradient(to right, #f57a37 0%, #f21b07 100%);
    background-image: -moz-linear-gradient(to right, #f57a37 0%, #f21b07 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.product-con .superior .slider-banner {
    width: 6.9rem;
    margin: 0 auto;
    padding-bottom: 0.2rem;
}

.product-con .superior .slider-banner .list {
    width: 100%;
    padding-bottom: 0.2rem;
}

.product-con .superior .slider-banner .list .item {
    width: 2.15rem;
    margin: 0 0.21rem 0.2rem 0;
    font-size: 0.26rem;
}

.product-con .superior .slider-banner .list .item:nth-of-type(3n) {
    margin-right: 0;
}

.product-con .superior .slider-banner .list .item .pictrue {
    width: 100%;
    height: 2.15rem;
    position: relative;
}

.product-con .superior .slider-banner .list .item .pictrue img {
    width: 100%;
    height: 100%;
    border-radius: 0.06rem;
}

.product-con .superior .slider-banner .list .item .name {
    color: #282828;
    margin-top: 0.12rem;
}

.product-con .superior .slider-banner .swiper-pagination-bullet {
    background-color: #999;
}

.product-con .superior .slider-banner .swiper-pagination-bullet-active {
    background-color: #e93323;
}

.mask {
    -webkit-filter: blur(2px);
    -moz-filter: blur(2px);
    -ms-filter: blur(2px);
    filter: blur(2px);
    z-index: 888 !important;
}

.product-con .product-intro .conter div {
    width: 100% !important;
}

.generate-posters {
    width: 100%;
    height: 1.7rem;
    background-color: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
    transform: translate3d(0, 100%, 0);
    -webkit-transform: translate3d(0, 100%, 0);
    -ms-transform: translate3d(0, 100%, 0);
    -moz-transform: translate3d(0, 100%, 0);
    -o-transform: translate3d(0, 100%, 0);
    transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    opacity: 0;
}

.generate-posters.on {
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    opacity: 1;
}

.generate-posters .item {
    flex: 50%;
    -webkit-flex: 50%;
    -ms-flex: 50%;
    text-align: center;
}

.generate-posters .item .iconfont {
    font-size: 0.8rem;
    color: #5eae72;
}

.generate-posters .item .iconfont.icon-haibao {
    color: #5391f1;
}

.noscroll {
    height: 100%;
    overflow: hidden;
}
</style>
